module.exports = __webpack_public_path__ + "media/caller_ringtone.726d08f8.mp3";